export default {
  forgot_password: {
    title: '重設密碼',
    required: '@:validation.required',
    incorrect_email_address: '@:validation.email_format',
    double_check_text: '@:login.double_check_text',
    forgot_password: '忘記密碼者',
    password_reset_text: '輸入電子郵件地址並按下寄送按鈕後會寄送確認信，請重設密碼。',
    submit: '寄送',
    mail_address: '請輸入電子郵件地址',
    input_label: '@:settings.user.email',
  },
}
